/**
 * description 视频弹窗控制器
 * created by ge.yuankai
 * created on 2018-04-17 
 */
"use strict";
angular.module("insertwordModule", [])
    .controller("insertwordCtrl", ['$scope', '$element', '$stateParams', '$q', '$modalInstance', '$compile', '$state', 'httpService', 'modalDialog', 'ueditorService', '$validation', 'localStorageService', '$timeout', '$sce', '$interval', function($scope, $element, $stateParams, $q, $modalInstance, $compile, $state, httpService, modalDialog, ueditorService, $validation, localStorageService, $timeout, $sce, $interval) {
        initStatus();
        initData();
        /**
         * [initStatus description] 初始化参数
         */
        function initStatus() {
            $scope.srcVideo = '';
            $scope.status = {
                
            }
            $scope.data = {
                result: '',
            };
        };

        function initData() {
        };
        $scope.import = function($files, $file, $newFiles) {
            debugger;
            if($files){
                var fd = new FormData();
                var name = $scope.status.files.name;
                fd.append("file", $newFiles[0]);
                fd.append("name", name);
                $scope.data.result = fd;
            }
            console.log(fd.get('file'));
        };

        $scope.cancel = function() {
            $modalInstance.dismiss();
        }
        /**
         * [uploadVideo description]初始化上传至吉木萨尔县在线的视频的方法
         * @return {[type]} [description]
         */
        $scope.confirm = function() {
            uploadtext();
        };

        function uploadtext() {
            var info = this;
            $.ajax({
                // url: '/mushu/classify/uploadExcel.do',
                type: 'POST',
                headers:{requestToken:sessionStorage.getItem('requestToken')},
                async: true, //修改以后可以出现蒙城
                // data: new FormData($('#uploadForm')[0]),
                data: $scope.data.result,
                // 告诉jQuery不要去处理发送的数据
                processData: false,
                // 告诉jQuery不要去设置Content-Type请求头
                contentType: false,
                beforeSend: function(responed) {},
                complete: function() {},
                success: function(responseStr) {
                    httpService.http("", {
                        // id: $scope.status.videosData[0].id
                    }, 'get').then((data) => {
                        info.$attrs.confirm(data);
                    }, (data) => {});
                }
            })

        }
        /**
         * [confirm] 确认
         * @return {[type]} [description]
         */
        // $scope.confirm = function() {
        //     if (!$scope.status.uploadSuccess) {
        //         modalDialog.alertType("", "视频正在上传中，请等待上传结束", "warning", "confirm");
        //         return;
        //     }
        //     if (!$scope.status.transcodSuccess) {
        //         modalDialog.alertType("", "视频正在转码中，请等待转码结束", "warning", "confirm");
        //         return;
        //     }
        //     //获取播放视频的图片 传给编辑器
        //     httpService.http("/mcnww/web/cloud/getMediaFrame.do", { id: $scope.status.videosData[0].id, libType: $scope.status.libType_v }, "get").then(function(data) {
        //         var data = {
        //             id: $scope.status.videosData[0].id,
        //             imgUrl: data.data.mediaFrameUrl,
        //             videoUrl: $scope.status.videosData[0].videoUrl,
        //             filename: $scope.status.videosData[0].filename,
        //             size: $scope.status.videosData[0].size,
        //             type: $scope.status.videosData[0].type
        //         };
        //         $modalInstance.close(data);
        //     });
        // };
    }]);